module.exports = __webpack_public_path__ + "static/media/operan.13adc94e.png";